import { Button } from '@mui/material'

interface Props {
  participantId: string | null
  onShowRounds: (participantId: string) => void
}

const ParticipantRoundsCell = ({ participantId, onShowRounds }: Props) => {
  return (
    <Button
      size="small"
      disabled={!participantId}
      onClick={() => participantId && onShowRounds(participantId)}
      sx={{
        textTransform: 'none',
        justifyContent: 'flex-start',
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: '10px',
        minWidth: 0,
      }}
    >
      View rounds
    </Button>
  )
}

export default ParticipantRoundsCell
